'use client'

import React, { useState } from 'react'

import { DEFAULT_PAGE_SIZE } from '@/config/settings'
import { DEFAULT_PAST_DATE_10_YEAR, DEFAULT_TODAY_DATE } from '@/lib/date/format-date'

import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react'

export enum OrderHistoryFilterSearchOption {
  itemNumber = 'itemNumber',
  orderNumber = 'orderNumber',
  requisitionNumber = 'requisitionNumber',
}

interface OrderHistoryFormTypes {
  dateFrom: Date
  dateTo: Date
  searchText: string
  searchOption: OrderHistoryFilterSearchOption
  pageSize: number
  currentPage: number
}

interface OrderHistoryFilterContextProps {
  formData: OrderHistoryFormTypes | null
  setFormData: Dispatch<SetStateAction<OrderHistoryFormTypes>>
}

const OrderHistoryFilterContext = React.createContext<OrderHistoryFilterContextProps>({
  formData: null,
  setFormData: () => null,
})

const OrderHistoryFilterContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [formData, setFormData] = useState<OrderHistoryFormTypes>({
    searchText: '',
    searchOption: OrderHistoryFilterSearchOption.itemNumber,
    dateFrom: DEFAULT_PAST_DATE_10_YEAR.toDate(),
    dateTo: DEFAULT_TODAY_DATE.toDate(),
    pageSize: DEFAULT_PAGE_SIZE,
    currentPage: 0,
  })

  return (
    <OrderHistoryFilterContext.Provider
      value={{
        formData,
        setFormData,
      }}
    >
      {children}
    </OrderHistoryFilterContext.Provider>
  )
}

export default OrderHistoryFilterContextProvider
